export default __webpack_public_path__ + "static/media/new-template-home.896f9ff2.png";